<template>
    <div class="giveaway knowledge-base">
        <knowledge-nav />

        <div class="giveaway__heading knowledge-base__heading">

            <svg width="744" height="108" viewBox="0 0 744 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M74.2402 72.5547H28.916V119H0.808594V2.40625H78.8047V24.1074H28.916V50.9336H74.2402V72.5547Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M192.512 63.1055C192.512 74.4766 190.404 84.5397 186.186 93.2949C181.969 102.05 175.963 108.803 168.169 113.555C160.428 118.253 151.592 120.602 141.663 120.602C131.733 120.602 122.925 118.333 115.237 113.795C107.55 109.204 101.544 102.664 97.2195 94.1758C92.9486 85.6875 90.7064 75.9447 90.4929 64.9473V58.3809C90.4929 46.9564 92.5749 36.8932 96.739 28.1914C100.956 19.4362 106.962 12.6829 114.757 7.93164C122.604 3.18034 131.52 0.804688 141.503 0.804688C151.379 0.804688 160.188 3.15365 167.928 7.85156C175.669 12.5495 181.675 19.2493 185.946 27.9512C190.27 36.5996 192.459 46.5293 192.512 57.7402V63.1055ZM163.925 58.2207C163.925 46.6361 161.976 37.8542 158.079 31.875C154.235 25.8424 148.71 22.8262 141.503 22.8262C127.409 22.8262 119.962 33.3965 119.161 54.5371L119.081 63.1055C119.081 74.5299 120.976 83.3119 124.766 89.4512C128.557 95.5905 134.189 98.6602 141.663 98.6602C148.763 98.6602 154.235 95.6439 158.079 89.6113C161.923 83.5788 163.871 74.9036 163.925 63.5859V58.2207Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M253.609 77.8398H238.394V119H210.287V2.40625H256.171C269.998 2.40625 280.809 5.47591 288.603 11.6152C296.397 17.7546 300.294 26.4297 300.294 37.6406C300.294 45.7552 298.639 52.4818 295.33 57.8203C292.073 63.1589 286.948 67.4831 279.955 70.793L304.298 117.799V119H274.189L253.609 77.8398ZM238.394 56.1387H256.171C261.51 56.1387 265.514 54.7507 268.183 51.9746C270.906 49.1452 272.267 45.2214 272.267 40.2031C272.267 35.1849 270.906 31.2611 268.183 28.4316C265.46 25.5488 261.456 24.1074 256.171 24.1074H238.394V56.1387Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M438.102 72.5547H392.778V119H364.671V2.40625H442.667V24.1074H392.778V50.9336H438.102V72.5547Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M500.961 77.8398H485.746V119H457.638V2.40625H503.523C517.35 2.40625 528.16 5.47591 535.955 11.6152C543.749 17.7546 547.646 26.4297 547.646 37.6406C547.646 45.7552 545.991 52.4818 542.681 57.8203C539.425 63.1589 534.3 67.4831 527.306 70.793L551.65 117.799V119H521.541L500.961 77.8398ZM485.746 56.1387H503.523C508.862 56.1387 512.866 54.7507 515.535 51.9746C518.257 49.1452 519.619 45.2214 519.619 40.2031C519.619 35.1849 518.257 31.2611 515.535 28.4316C512.812 25.5488 508.808 24.1074 503.523 24.1074H485.746V56.1387Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M640.213 69.5918H596.01V97.3789H648.221V119H567.903V2.40625H648.381V24.1074H596.01V48.6914H640.213V69.5918Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M735.263 69.5918H691.06V97.3789H743.271V119H662.952V2.40625H743.431V24.1074H691.06V48.6914H735.263V69.5918Z" fill="#F0F5FD" fill-opacity="0.1"/>
            </svg>


            <div class="giveaway__heading-title knowledge-base__heading-title">
                {{$store.getters.t('facilities_store_form_giveaway')}}
            </div>


        </div>

        <div class="giveaway__grid knowledge-base__grid">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-3">
                        <aside class="sidebar product--sidebar" @click="filterToggle">

                            <div class="product--sidebar-wrapper">

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse1" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse1">
                                        <h4>{{$store.getters.t('facilities_filter_location')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse1">
                                        <div class="card-content">
                                            <div class="form-group mt-2">
                                                <label for="city_id">{{$store.getters.t('donors_locality')}}</label>
                                                <div class="" style="position:relative;">
                                                    <input v-model="locationSearch" class="form-control city-filter" autocomplete="off" id="city_id" :placeholder="$store.getters.t('donors_start_typing_locality')"/>
                                                    <div class="search-result" v-if="locationItems.length">
                                                        <div class="city-item" v-for="location in locationItems" @click="setCityId(location)">{{location.name}}</div>
                                                    </div>
                                                    <div class="search-result" v-if="!locationItems.length && locationSearch && locationSearch !== locationSelected">
                                                        <div class="city-item">{{$store.getters.t('facilities_store_form_nothing_found')}}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse2" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse2">
                                        <h4>{{$store.getters.t('facilities_store_form_category')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse2">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="giveawayCategory === 'medical'"
                                                           @change="dynamicFilter('giveawayCategory','medical', $event)" id="filter_medical" class="">
                                                    <label for="filter_medical">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_medical')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="giveawayCategory === 'nutrition'"
                                                           @change="dynamicFilter('giveawayCategory','nutrition', $event)" id="filter_nutrition" class="">
                                                    <label for="filter_nutrition">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_nutrition')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="giveawayCategory === 'other'"
                                                           @change="dynamicFilter('giveawayCategory','other', $event)" id="filter_other" class="">
                                                    <label for="filter_other">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_other')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse3" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse3">
                                        <h4>{{$store.getters.t('facilities_store_form_availability')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse3">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'city'"
                                                           @change="dynamicFilter('range','city', $event)" id="range_filter_city" class="">
                                                    <label for="range_filter_city">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_city')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'region'"
                                                           @change="dynamicFilter('range','region', $event)" id="range_filter_region" class="">
                                                    <label for="range_filter_region">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_region')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'country'"
                                                           @change="dynamicFilter('range','country', $event)" id="range_filter_country" class="">
                                                    <label for="range_filter_country">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_country')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'abroads'"
                                                           @change="dynamicFilter('range','abroads', $event)" id="range_filter_abroads" class="">
                                                    <label for="range_filter_abroads">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_abroad')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>


                            <button id="sidebar-toggle" @click.prevent="sidebarFilterToggle">

                                <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0.882353C0 0.395037 0.466882 0 1.04278 0H21.8984C22.4743 0 22.9412 0.395037 22.9412 0.882353C22.9412 1.36967 22.4743 1.76471 21.8984 1.76471H1.04278C0.466882 1.76471 0 1.36967 0 0.882353Z" fill="white"/>
                                    <path d="M7.05884 9.7059C7.05884 9.21859 7.36273 8.82355 7.73757 8.82355H15.2036C15.5785 8.82355 15.8824 9.21859 15.8824 9.7059C15.8824 10.1932 15.5785 10.5883 15.2036 10.5883H7.73757C7.36273 10.5883 7.05884 10.1932 7.05884 9.7059Z" fill="white"/>
                                    <path d="M4.41187 5.2941C4.41187 4.80679 4.89809 4.41174 5.49784 4.41174H17.4435C18.0433 4.41174 18.5295 4.80679 18.5295 5.2941C18.5295 5.7814 18.0433 6.17645 17.4435 6.17645H5.49784C4.89809 6.17645 4.41187 5.7814 4.41187 5.2941Z" fill="white"/>
                                    <path d="M9.88229 13.2353C9.29761 13.2353 8.82349 13.6303 8.82349 14.1176C8.82349 14.605 9.29761 15 9.88229 15H13.0588C13.6435 15 14.1176 14.605 14.1176 14.1176C14.1176 13.6303 13.6435 13.2353 13.0588 13.2353H9.88229Z" fill="white"/>
                                </svg>


                            </button>


                        </aside>
                    </div>

                    <div class="col-md-12 col-lg-9">


                        <div class="giveaway__store knowledge-base__store">
                            <a href="/auth/login" class="btn auto-help__store-btn knowledge-base__store-btn" v-if="!user">
                                {{$store.getters.t('facilities_add_ad')}}
                            </a>
                            <button class="btn giveaway__store-btn knowledge-base__store-btn" v-else @click.prevent="showStoreForm = !showStoreForm">
                                {{$store.getters.t('facilities_add_ad')}}
                            </button>

                            <transition name="slide">
                                <store-form @storeForm="refreshList" page-type="giveaway" type="STORE" v-show="showStoreForm"/>
                            </transition>

                        </div>

                        <template v-if="!loaded">
                            <div class="giveaway__item knowledge-base__item knowledge-base__item--empty d-flex">
                                <div class="LoaderBalls">
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else>


                            <div v-if="list.length">
                                <div class="giveaway__item" v-for="(item, idx) in list">
                                    <card-horizontal @deleted="getGiveAway" :facility="item" :pets="userPets" :projects="userProjects" :index="idx" :key="idx" :user="user"/>
                                </div>

                                <div class="row" v-if="pageCount > 1">
                                    <div class="col-md-12">
                                        <div class="pagination-area pull-right">
                                            <nav class="navigation pagination" role="navigation">
                                                <div class="nav-links">
                                                    <paginate
                                                        v-model="page"
                                                        :page-count="pageCount"
                                                        :click-handler="paginateClickCallback"
                                                        :prev-text="''"
                                                        :next-text="''"
                                                        :container-class="'className'"
                                                        :page-class="'page-numbers'"
                                                        :page-link-class="''"
                                                        :active-class="'current'"
                                                        :prev-class="'prev page-numbers'"
                                                        :prev-link-class="'lnr lnr-arrow-left'"
                                                        :next-class="'next page-numbers'"
                                                        :next-link-class="'lnr lnr-arrow-right'"
                                                    >
                                                    </paginate>
                                                </div>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div class="giveaway__item knowledge-base__item knowledge-base__item--empty d-flex">
                                    {{$store.getters.t('facilities_list_empty')}}
                                </div>
                            </div>

                        </template>





                    </div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>

import KnowledgeNav from "../KnowledgeBase/KnowledgeNav";
import CardHorizontal from "./CardHorizontal";
import StoreForm from "./StoreForm";
import {paginationScrollTo} from "../helpers/helpers";

export default {
    name: "GiveAwayFacilities",
    props: ['facilitiesData'],
    components:{
        KnowledgeNav,
        CardHorizontal,
        StoreForm,
    },
    data(){
        return{
            showStoreForm: false,
            userPets: [],
            userProjects: [],
            list: [],
            page: 1,
            pageCount: 0,

            loaded: true,

            searchBy: null,

            locationSearch: null,
            locationSelected: null,
            selectedLocationId: null,
            locationItems: [],

            range: null,
            giveawayCategory: null

        }
    },

    mounted(){
        this.loaded = false

        this.getUserPetsAndProdjects()
        this.getUserPetsAndProdjects('projects')

        this.getGiveAway()
    },

    watch:{
        list(){
            this.loaded = false
            setTimeout(()=>{
                this.loaded = true
            }, 1000)
        },

        locationSearch(value) {
            if (!value) {
                this.locationSelected = null;
                this.searchBy = null;
                this.locationItems = [];
                this.selectedLocationId = null;
                return false;
            }

            if (value !== this.locationSelected) {
                this.searchLocations();
            }
        },

        selectedLocationId() {
            this.getGiveAway(true);
        },

        giveawayCategory(){
            this.getGiveAway(true);
        },

        range() {
            this.getGiveAway(true);
        },

    },

    computed:{
        user(){
            return this.$store.getters.getUserData
        }
    },

    methods:{


        getUserPetsAndProdjects(type = 'pets'){
            if (!this.user) return

            let url = `/api/user/pets-list`


            if(type === 'projects') url = `/api/user/projects-list`

            axios(url)
                .then(response => {
                    response = response.data

                    if(response.success){
                        if(type === 'projects') return this.userProjects = response.data
                        this.userPets = response.data
                    }

                })
                .catch()

        },

        dynamicFilter(selfObjectParam, filter, event){

            let checked = event.target.checked

            if(!checked) return this[selfObjectParam] = null
            return this[selfObjectParam] = filter
        },

        paginateClickCallback(pageNum) {
            this.page = pageNum;

            paginationScrollTo('.giveaway__grid')

            this.getGiveAway();
        },

        refreshList(){
            this.getGiveAway(true)
        },

        getGiveAway(resetPage){
            let url = `/api/facilities`

            if(resetPage){
                this.page = 1
            }


            axios(url, {
                params: {
                    page: this.page,
                    type: 'giveaway',
                    giveaway_category: this.giveawayCategory,
                    city_id: this.searchBy === 'city' ? this.selectedLocationId : null,
                    region_id: this.searchBy === 'region' ? this.selectedLocationId : null,
                    range: this.range,
                    per_page: 5,
                }
            })
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.list = response.data
                        this.page = response.meta.current_page
                        this.pageCount = response.meta.last_page


                    }

                })
                .catch(error => {
                    error = error.response.data

                    console.log(error)

                })
        },

        setCityId(location) {
            this.selectedLocationId = location.id;
            this.locationSearch = location.name;
            this.locationSelected = location.name;
            this.searchBy = location.type;
            this.locationItems = [];
        },

        searchLocations() {
            let self = this;
            let url = `/api/locations`,
                params = {
                    city_id: null,
                    region_id: null,
                    country_id: null,
                    query: self.locationSearch
                }

            axios.get(url, {params: params})
                .then(response => {
                    response = response.data;
                    if (response.success) {

                        self.locationItems = response.data



                    }
                })
                .catch((error) => {

                    error = error.response.data

                    console.log(error)

                    alert(this.$store.getters.t('common_error_reload'));
                })
        },


        sidebarFilterToggle(){
            let productFilter = document.querySelector('.product--sidebar');
            let body = document.querySelector('body');
            productFilter.classList.toggle('product-sidebar--open');
            body.classList.toggle('product-sidebar--open');
        },

        filterToggle(e){
            if(window.matchMedia("min-width: 992px").matches) return

            let filterWrapper = document.querySelector('.product--sidebar-wrapper');
            let filterBtn = document.getElementById('sidebar-toggle');

            if(!filterWrapper.contains(e.target) && !filterBtn.contains(e.target)){
                let productFilter = document.querySelector('.product--sidebar');
                let body = document.querySelector('body');

                productFilter.classList.remove('product-sidebar--open');
                body.classList.remove('product-sidebar--open');
                return;

            }

        }

    }


}
</script>

<style scoped>

</style>
